module.exports = __webpack_public_path__ + "static/media/partner03.866abde8.svg";